import React, { Component } from 'react';
import cx from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import ProtectedComponent from './ProtectedComponent';
import Logo from './Logo';
import EngageLogo from './EngageLogo';
import AccountNav from './AccountNav';
import NavLink from './NavLink';
import { IndexLink } from 'react-router';
import Roles from '../constants/Roles';
import RequiresActiveSubscription from './RequiresActiveSubscription';
import Settings from '../utils/Settings';
import Billing from '../apps/Billing';

const messages = defineMessages({
  guides: {
    id: 'section.guides',
    defaultMessage: 'Dialogue Builder',
    description: 'The button text for the Guides link.'
  },
  products: {
    id: 'section.products',
    defaultMessage: 'Product Builder',
    description: 'The button text for the Products link.'
  },
  analytics: {
    id: 'section.analytics',
    defaultMessage: 'Analytics',
    description: 'The button text for the Analytics link.'
  },
  compliance: {
    id: 'section.compliance',
    defaultMessage: 'Compliance',
    description: 'The button text for the Compliance link.'
  },
  login: {
    id: 'section.account.login',
    defaultMessage: 'login',
    description: 'The button text for the login link.'
  },
  userManagement: {
    id: 'section.userManagement',
    defaultMessage: 'Users',
    description: 'The button text for the user management.'
  },
  publish: {
    id: 'section.publish',
    defaultMessage: 'Publish',
    description: 'The button text for the publishing changes.'
  },
  bankInfo: {
    id: 'section.bankInfo',
    defaultMessage: 'Bank',
    description: 'The button for bank link'
  },
  billing: {
    id: 'section.billing',
    defaultMessage: 'Billing',
    description: 'The button text for the billing link.'
  }
});

function renderAccountNav() {
  return <AccountNav />;
}

class NavBar extends Component {

  render() {
    const linkClasses = cx({
      'navbar-link': true,
      'flex-container': true,
      'flex-vertical': true
    });

    return (
      <nav className="navbar flex-container">
        <div className="navbar-title">
          <IndexLink to="/" className="navbar-home navbar-link flex-container flex-vertical">
            <div className="logo-wrapper">
              { Settings.envFeatures.get('dialogue') ?
                <EngageLogo disableStyles/> :
                <Logo/>
              }
            </div>
          </IndexLink>
        </div>
        <div className="navbar-links flex-element flex-container">
          { Settings.envFeatures.get('dialogue') ? (
            <RequiresActiveSubscription>
              <ProtectedComponent role={Roles.BANK_MANAGER}>
                <NavLink to="/bank-info" className={linkClasses}>
                  <FormattedMessage {...messages.bankInfo} />
                </NavLink>
              </ProtectedComponent>
            </RequiresActiveSubscription>
          ) : null }
          { Settings.envFeatures.get('dialogue') ? (
            <RequiresActiveSubscription>
              <ProtectedComponent role={Roles.GUIDE_MANAGER}>
                <NavLink to="/dialogues" className={linkClasses}>
                  <FormattedMessage {...messages.guides} />
                </NavLink>
              </ProtectedComponent>
            </RequiresActiveSubscription>
          ) : null }
          { Settings.envFeatures.get('dialogue') ? (
            <RequiresActiveSubscription>
              <ProtectedComponent role={Roles.PRODUCT_MANAGER}>
                <NavLink to="/products" className={ linkClasses }>
                  <FormattedMessage { ...messages.products } />
                </NavLink>
              </ProtectedComponent>
            </RequiresActiveSubscription>
          ) : null }
          { Settings.envFeatures.get('dialogue') ? (
            <RequiresActiveSubscription>
              <ProtectedComponent role={Roles.PUBLISHING}>
                <NavLink to="/publish" className={ linkClasses }>
                  <FormattedMessage { ...messages.publish } />
                </NavLink>
              </ProtectedComponent>
            </RequiresActiveSubscription>
          ) : null }
          <RequiresActiveSubscription>
            <ProtectedComponent role={Roles.ANALYTICS_DASHBOARD}>
              <NavLink to="/analytics" className={ linkClasses }>
                <FormattedMessage { ...messages.analytics } />
              </NavLink>
            </ProtectedComponent>
          </RequiresActiveSubscription>
          { Settings.envFeatures.get('bigBank') ? (
            <RequiresActiveSubscription>
              <ProtectedComponent role={Roles.COMPLIANCE_DASHBOARD}>
                <NavLink to="/compliance" className={ linkClasses }>
                  <FormattedMessage { ...messages.compliance } />
                </NavLink>
              </ProtectedComponent>
            </RequiresActiveSubscription>
          ) : null }
          <ProtectedComponent role={Roles.USER_MANAGER}>
            <NavLink to="/user-management" className={ linkClasses }>
              <FormattedMessage { ...messages.userManagement } />
            </NavLink>
          </ProtectedComponent>
        </div>
        <div className="navbar-account flex-container">
          <ProtectedComponent hideWhenAuthenticated alternateComponent={ renderAccountNav }>
            <NavLink to="/account/login" className={ linkClasses }>
              <FormattedMessage { ...messages.login } />
            </NavLink>
          </ProtectedComponent>
        </div>
      </nav>
    );
  }

}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js